var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep10To8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 108,
    viewBox: "0 0 257 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70711 0.292893C8.31658 -0.097631 7.68342 -0.0976312 7.29289 0.292893L0.928932 6.65685C0.538407 7.04738 0.538407 7.68054 0.928931 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM236 78.8348L28 78.8348L28 80.8348L236 80.8348L236 78.8348ZM8.99999 59.8348L9 1L7 1L6.99999 59.8348L8.99999 59.8348ZM255 99.8348L255 108L257 108L257 99.8348L255 99.8348ZM28 78.8348C17.5066 78.8348 8.99999 70.3282 8.99999 59.8348L6.99999 59.8348C6.99999 71.4328 16.402 80.8348 28 80.8348L28 78.8348ZM236 80.8348C246.493 80.8348 255 89.3414 255 99.8348L257 99.8348C257 88.2369 247.598 78.8348 236 78.8348L236 80.8348Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep10To8);
export default __webpack_public_path__ + "static/media/step_10_to_8.6ca5b946bc23cb4b1f3a6b4a3c4ffeb3.svg";
export { ForwardRef as ReactComponent };